import type { ApplicationInsights } from "@microsoft/applicationinsights-web";

const TRANSPARENT_PROPS = new Set(["then", "catch", "finally", "toJSON"]);

const createRecursiveProxy = (path: string): unknown => {
	const callable = (...args: unknown[]) => {
		console.log(`[@packsize/application-monitoring | ApplicationInsights] ${path}`, ...args);

		return createRecursiveProxy(path);
	};

	return new Proxy(callable, {
		get: (_target, prop) => {
			if (typeof prop === "symbol" || TRANSPARENT_PROPS.has(prop as string)) {
				return undefined;
			}

			return createRecursiveProxy(`${path}.${prop as string}`);
		},
	});
};

export const createApplicationInsightsConsoleProxy = (): ApplicationInsights =>
	new Proxy({} as ApplicationInsights, {
		get: (_target, prop) => {
			if (typeof prop === "symbol" || TRANSPARENT_PROPS.has(prop as string)) {
				return undefined;
			}

			return createRecursiveProxy(prop as string);
		},
	});
